import { ItemAvatarSkeletonComponent } from './item-avatar-skeleton.component';

export default angular
  .module('sfMobile.components.item-avatar-skeleton', [
    'sfMobile.components.text-skeleton',
    'sfMobile.components.avatar-skeleton',
  ])
  .component('sfItemAvatarSkeleton', ItemAvatarSkeletonComponent).name;
